const THOUSAND = 1000

export const formatValuesToSelectItems = (obj: { [key: string]: string }) =>
  Object.values(obj).map((el) => ({
    value: el,
    label: el,
  }))

export const formatNumberWithCommas = (number: number | string) => {
  const [integerPart, decimalPart] = number.toString().split('.')

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger
}

export const formatNumberWithKilo = (value: number | string) => {
  const number =
    typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value

  if (isNaN(number) || number === 0) return '0'

  if (number < THOUSAND) {
    return number.toString()
  }

  const formatted = (number / THOUSAND).toFixed(1)

  return formatted.endsWith('.0')
    ? `${Math.floor(number / THOUSAND)}k`
    : `${formatted}k`
}
